module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Black-Alphabetic.88d9b4a0.woff";